if (!customElements.get('quick-add-modal')) {
  customElements.define(
    'quick-add-modal',
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
      }

      hide(preventFocus = false) {
        const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (cartNotification) cartNotification.setActiveElement(this.openedBy);
        this.modalContent.innerHTML = '';
        if (preventFocus) this.openedBy = null;
        super.hide();
      }

      show(opener) {
        opener.setAttribute('aria-disabled', true);
        opener.classList.add('loading');
        opener.querySelector('.loading-overlay__spinner').classList.remove('hidden');

        // Show immediate spinner in modal
        this.modalContent.innerHTML = `
          <div style="padding:3rem;text-align:center;">
            <div class="loading-overlay__spinner spinner" style="margin:auto;"></div>
          </div>`;
        super.show(opener);

        // Build product section fetch URL
        const sectionId =
          document.querySelector('[id^="MainProduct-template--"]')?.id?.replace('MainProduct-', '') ||
          'template--19912127021156__main';
        const baseUrl = opener.getAttribute('data-product-url');
        const fetchUrl = `${baseUrl}?section_id=${sectionId}`;

        fetch(fetchUrl)
          .then((response) => {
            if (!response.ok) throw new Error(`HTTP ${response.status}`);
            return response.text();
          })
          .then((responseText) => {
            const doc = new DOMParser().parseFromString(responseText, 'text/html');

            // Match the section we actually want
            this.productElement =
              doc.querySelector('section[id^="MainProduct-template--"]') ||
              doc.querySelector('section[id^="ProductInfo-template--"]') ||
              doc.querySelector('section[id*="__main"]');

            if (!this.productElement) throw new Error('Product section not found in response.');

            this.preventDuplicatedIDs();
            this.removeDOMElements();
            this.setInnerHTML(this.modalContent, this.productElement.innerHTML);

            if (window.Shopify && Shopify.PaymentButton) Shopify.PaymentButton.init();
            if (window.ProductModel) window.ProductModel.loadShopifyXR();

            this.removeGalleryListSemantic();
            this.updateImageSizes();
            this.preventVariantURLSwitching();
          })
          .catch((e) => {
            console.error('[Quick Add Error]', e);
            this.modalContent.innerHTML = `
              <div style="padding:2rem;text-align:center;">
                Error loading product data.
              </div>`;
          })
          .finally(() => {
            opener.removeAttribute('aria-disabled');
            opener.classList.remove('loading');
            opener.querySelector('.loading-overlay__spinner').classList.add('hidden');
          });
      }

      setInnerHTML(element, html) {
        element.innerHTML = html;
        element.querySelectorAll('script').forEach((oldScriptTag) => {
          const newScriptTag = document.createElement('script');
          Array.from(oldScriptTag.attributes).forEach((attr) => {
            newScriptTag.setAttribute(attr.name, attr.value);
          });
          newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
          oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
        });
      }

      preventVariantURLSwitching() {
        const picker = this.modalContent.querySelector('variant-radios,variant-selects');
        if (picker) picker.setAttribute('data-update-url', 'false');
      }

      removeDOMElements() {
        this.productElement.querySelectorAll('pickup-availability, product-modal, modal-dialog').forEach((el) => el.remove());
      }

      preventDuplicatedIDs() {
        const sectionId = this.productElement.dataset.section;
        this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(sectionId, `quickadd-${sectionId}`);
        this.productElement.querySelectorAll('variant-selects, variant-radios, product-info').forEach((el) => {
          el.dataset.originalSection = sectionId;
        });
      }

      removeGalleryListSemantic() {
        const galleryList = this.modalContent.querySelector('[id^="Slider-Gallery"]');
        if (!galleryList) return;
        galleryList.setAttribute('role', 'presentation');
        galleryList.querySelectorAll('[id^="Slide-"]').forEach((li) => li.setAttribute('role', 'presentation'));
      }

      updateImageSizes() {
        const product = this.modalContent.querySelector('.product');
        if (!product || !product.classList.contains('product--columns')) return;
        const mediaImages = product.querySelectorAll('.product__media img');
        if (!mediaImages.length) return;

        let sizes = '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';
        if (product.classList.contains('product--medium')) sizes = sizes.replace('715px', '605px');
        else if (product.classList.contains('product--small')) sizes = sizes.replace('715px', '495px');

        mediaImages.forEach((img) => img.setAttribute('sizes', sizes));
      }
    }
  );
}